import { FlaskConical } from "lucide-react";

/**
 * PilotDemoBanner
 * A compact, respectful disclosure strip for pages that describe or illustrate
 * coordination capabilities not yet in operational use. Keeps WHO's marketing
 * narrative honest while the referral/handoff pathway is being built.
 */
export default function PilotDemoBanner({
  text = "Pilot in development · imagery and data on this page are illustrative demonstrations of planned WHO capabilities.",
  tone = "cream",
}) {
  const palette =
    tone === "navy"
      ? "bg-navy-deep/60 text-cream border-y border-gold/30"
      : "bg-cream-panel text-navy/80 border-y border-gold/40";

  return (
    <div
      className={`w-full ${palette}`}
      data-testid="pilot-demo-banner"
      role="note"
    >
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-3 flex items-start sm:items-center gap-3">
        <span
          className="shrink-0 inline-flex items-center justify-center w-6 h-6 rounded-full bg-gold/20 text-gold-deep"
          aria-hidden
        >
          <FlaskConical className="w-3.5 h-3.5" strokeWidth={2.5} />
        </span>
        <p className="text-xs sm:text-sm leading-relaxed">
          <span className="font-semibold uppercase tracking-wider text-gold-deep mr-2">
            Pilot
          </span>
          {text}
        </p>
      </div>
    </div>
  );
}
